class ProductMessage extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (this.classList.contains('product-message--out')) {
      this.show();
      
      if (this.dataset.transient) {
        setTimeout(() => {
          this.hide();
        }, this.dataset.transient * 1000);
      }
    }
  }

  show() {
    this.classList.remove('product-message--out');
  }

  hide() {
    this.classList.add('product-message--out');
    

    setTimeout(() => {
      this.remove();
    }, 3000);
  }
}

class CopyLinkButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.addEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', () => this.copyLink());
  }

  async copyLink() {
    const productUrl = window.location.href;
    const productTitle = document.querySelector('.product-title')?.textContent?.trim() || 'Check out this product';

    if (navigator.share) {
      try {
        await navigator.share({
          title: productTitle,
          text: 'Check out this amazing product!',
          url: productUrl
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error sharing:', err);
          this.fallbackCopy(productUrl);
        }
      }
    } else {
      this.fallbackCopy(productUrl);
    }
  }

  fallbackCopy(url) {
    navigator.clipboard.writeText(url).then(() => {
      this.showToast('Product link copied to clipboard! You can now paste it anywhere to share.');
    }).catch(err => {
      console.error('Failed to copy:', err);
      this.showToast('Failed to copy link to clipboard', 'error');
    });
  }

  showToast(message, type = 'success', duration = 2) {

    const toast = document.createElement('product-message');
    toast.className = `product-message product-message--${type} product-message--out`;
    toast.setAttribute('data-transient', duration);
    
    const inner = document.createElement('div');
    inner.className = 'product-message__inner';

    const icon = document.createElement('div');
    icon.className = 'icon';
    icon.innerHTML = type === 'success' 
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14v-4m0-4h.01M19 10a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>';
    

    const text = document.createElement('div');
    text.textContent = message;
    

    inner.appendChild(icon);
    inner.appendChild(text);
    toast.appendChild(inner);
    

    document.body.appendChild(toast);
    

    setTimeout(() => toast.init(), 10);
  }
}

if (!customElements.get('product-message')) {
  customElements.define('product-message', ProductMessage);
}

if (!customElements.get('copy-link-button')) {
  customElements.define('copy-link-button', CopyLinkButton);
}
